import { createRouter, createWebHistory } from "vue-router";
import Home from "@/components/pages/dashboard/Home.vue";
import Settings from "@/components/pages/dashboard/Settings.vue";
import Profile from "@/components/pages/dashboard/Profile.vue";
import OpenClaw from "@/components/pages/dashboard/OpenClaw.vue";
import Login from "@/components/pages/auth/Login.vue";
import Register from "@/components/pages/auth/Register.vue";
import VerifyEmail from "@/components/pages/auth/VerifyEmail.vue";
import Terms from "@/components/pages/other/Terms.vue";
import Cashout from "@/components/pages/cashout/Cashout.vue";
import Tips from "@/components/molecules/Tips.vue";
// import TipDetails from "@/components/molecules/TipDetails.vue";
import TipPage from "@/components/pages/tip/TipPage.vue"
import AccaShare from "@/components/pages/share/AccaShare.vue";
import TipShare from "@/components/pages/share/TipShare.vue";
import firebase from "@/firebase";
import store from "@/store";


const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
  },
  {
    path: "/register/verify",
    name: "VerifyEmail",
    component: VerifyEmail,
  },
  {
    path: "/terms",
    name: "Terms",
    component: Terms,
  },
  {
    path: "/virtual-cashout",
    name: "Cashout",
    component: Cashout,
  },
  {
    path: "/profile",
    component: Profile,
    name: "Profile",
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/settings",
    component: Settings,
    name: "Settings",
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/openclaw",
    component: OpenClaw,
    name: "OpenClaw",
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/",
    component: Home,
    meta: {
      requiresAuth: true,
    },
    children: [
      { path: "", component: Tips, name: "Home" },
      // { path: "tips/:id", component: TipDetails },
    ],
  },
  {
    path: "/tips/:id",
    component: TipPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/acca-share/:id",
    component: AccaShare,
    name: "AccaShare",
  },
  {
    path: "/tip-share/:id",
    component: TipShare,
    name: "TipShare",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});



router.beforeEach(async (to, from, next) => {
  // Public share route: no auth checks at all (used by puppeteer/og preview)
  if (to.name === "AccaShare") {
    next();
    return;
  }
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const requiresAdmin = to.matched.some((record) => record.meta.requiresAdmin);
  let user = await firebase.getCurrentUser();
  if (requiresAuth && !user) {
    next({ name: "Login" });
    return;
  }
  if (user && !user.emailVerified && to.name !== 'VerifyEmail') {
    next({ name: "VerifyEmail" });
    return;
  }
  if (requiresAdmin) {
    // Force-refresh once so the admin claim picks up right after grant-admin.js was run.
    let isAdmin = store.state && store.state.isAdmin;
    if (!isAdmin && user) {
      try {
        const tokenResult = await user.getIdTokenResult(true);
        isAdmin = tokenResult.claims && tokenResult.claims.admin === true;
        store.commit("setAdmin", isAdmin);
      } catch (e) {
        isAdmin = false;
      }
    }
    if (!isAdmin) {
      next({ name: "Home" });
      return;
    }
  }
  if (to.name === "Login" && user) {
    next({ name: "Home" });
    return;
  }
  next();
});

export default router;
